import SubCategoryCardContainer from "./SubCategoryCardContainer";

export default SubCategoryCardContainer;
